import React from 'react'
import PropTypes from 'prop-types'
import ContentContainer from 'components/ContentContainer'

const CreateCodeSetContentContainer = ({ children }) => (
  <ContentContainer top="calc(20vh - 40px)">
    {children}
  </ContentContainer>
)
CreateCodeSetContentContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,

}
export default CreateCodeSetContentContainer
